export const formatCurrency = (value: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)

export const parseCurrencyToNumber = (value: string) => {
  const digits = parseInt(value.replace(/[^0-9]/g, ''), 10)
  return isNaN(digits) ? 0 : digits / 100
}
